import { render, staticRenderFns } from "./CopyrightAssignmentTransferEscalations.vue?vue&type=template&id=f57874aa&scoped=true&"
import script from "./CopyrightAssignmentTransferEscalations.vue?vue&type=script&lang=js&"
export * from "./CopyrightAssignmentTransferEscalations.vue?vue&type=script&lang=js&"
import style0 from "./CopyrightAssignmentTransferEscalations.vue?vue&type=style&index=0&id=f57874aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f57874aa",
  null
  
)

export default component.exports